export const DISTRIBUTE_ACTION_HORIZONTAL_LABEL = 'Distribute horizontal spacing';
export const DISTRIBUTE_ACTION_VERTICAL_LABEL = 'Distribute vertical spacing';
